(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ProductWizard", [], factory);
	else if(typeof exports === 'object')
		exports["ProductWizard"] = factory();
	else
		root["ProductWizard"] = factory();
})(this, function() {
return 